import React, { useEffect, useRef, useState } from 'react';
import './CaseStudiesSection.css';
import CaseStudyCard from './CaseStudyCard';

import cs1 from '../assets/cs1.webp';
import cs2 from '../assets/cs2.webp';
import cs3 from '../assets/cs3.webp';

const caseStudies = [
  {
    title: 'Flipped Normals',
    description: 'Full Marketplace Migration In Just 2 Months Led To Scalable Infrastructure and Improved Traffic',
    image: cs1,
  },
  {
    title: 'AppTweak',
    description: 'How AppTweak improved the loading time by 80% with a new dashboard',
    image: cs2,
  },
  {
    title: 'Environmental Intellect',
    description: 'Ei clients save up over $200k in contractor costs',
    image: cs3,
  },
];

const CaseStudiesSection = () => {
  const centerCardRef = useRef(null);
  const previousScrollY = useRef(window.scrollY);
  const yOffset = useRef(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) return; // Disable animation on mobile

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      if (centerCardRef.current) {
        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffset.current + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffset.current = newOffset;

        centerCardRef.current.style.transform = `translate3d(0, ${newOffset}px, 0)`;
      }

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  return (
    <section id="case-studies" className="case-studies-section">
      <div className="container">
        {/* Header */}
        <div className="case-header">
          <div className="case-header-left">
            <h2>
              OUR
              <span className="blue-text"><br /> LATEST PROJECTS</span>
            </h2>
          </div>
          <div className="case-header-right">
            <p>
              Since 2020, we've delivered more than 300 web and software products, in over 15 different industries.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className={`case-card-group ${isMobile ? 'mobile' : ''}`}>
          {caseStudies.map((item, i) => (
            <div
              key={i}
              ref={i === 1 ? centerCardRef : null}
              className="case-card-wrapper"
            >
              <CaseStudyCard
                title={item.title}
                description={item.description}
                image={item.image}
                isCentered={i === 1 && !isMobile}
              />
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="case-btn-wrapper">
          {/* Button content remains same */}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;